<template>
  <div class="container">
    <div class="news">
      <img class="back_icon" :src='backImg' alt="">
      <div class="user">
        <img class="user_icon" :src='$store.state.headimgurl' alt="">
        <div class="user_right">
            <div class="font">{{$store.state.nickname}}</div>
        </div>
      </div>
    </div>   
    <div class="learn">
        <div class="learn_title">我的学习</div>
        <div class="learn_process" @click="toGh">
          <img class="learn_icon" :src='ganhuoImg' alt="">
          <div class="learn_font">干货</div>
          <div class="learn_font">已学{{getStudyDetails.self_article_num}}条/{{getStudyDetails.all_article_num}}条小干货</div>
        </div>
        <div class="learn_process" @click="toRecord">
          <img class="learn_icon" :src='kechengImg' alt="">
          <div class="learn_font">课程</div>
          <div class="learn_font">已学{{getStudyDetails.self_course_num}}门/{{getStudyDetails.all_course_num}}门课程</div>
        </div>
    </div>
    <div class="content">
      <div class="item" @click="mycoupons" >
        <div class="item_left">
          <img class="item_icon" :src='youhuiImg' alt="">
          <div class="item_font">我的优惠券</div>
        </div>
        <img class="right_icon" :src='rightImg' alt="">
      </div>
      <div class="item" @click="mylabel">
        <div class="item_left">
          <img class="item_icon" :src='bianqianImg'  alt="">
          <div class="item_font">我的标签(限时完善标签，获得优惠券)</div>
        </div>
        <img class="right_icon" :src='rightImg' alt="">
      </div>
      <div class="item" @click="clear">
        <div class="item_left">
          <img class="item_icon1" :src='clearImg'  alt="">
          <div class="item_font">清除缓存</div>
        </div>
        <img class="right_icon" :src='rightImg' alt="">
      </div>
      <div class="item1">
        <div class="item_left">
          <img class="item_icon" :src='weixinImg' alt="">
          <div class="item_font" v-clipboard:copy="'xiaoyimawork'" v-clipboard:success="onCopy">联系小姨妈微信xiaoyimawork</div>
        </div>
        <!-- <img class="right_icon" :src='rightImg' alt=""> -->
        <div class="item_font" v-clipboard:copy="'xiaoyimawork'" v-clipboard:success="onCopy">点击复制</div>
      </div>
      
    </div>
    <div class="bottom">
        <div class="bottom_item" @click="toindex()">
          <img class="bottom_icon" :src='ghImg' alt="">
          <!-- <div class="bottom_text">小干货</div> -->
          <div class="bottom_text">小干货</div>
        </div>
        <div class="bottom_item" @click="toKc()">
          <img class="bottom_icon" :src='kcImg' alt="">
          <div class="bottom_text">课程</div>
        </div>
        <div class="bottom_item">
          <img class="bottom_icon" :src='mineImg' alt="">
          <div class="bottom_text_chose">我的</div>
        </div>
    </div>
  </div>
</template>
<style scoped>
.container{
  overflow-y: scroll;
  /* font-family:Helvetica, Tahoma, Arial, "PingFang SC", "Hiragino Sans GB", "Heiti SC", "Microsoft YaHei", "WenQuanYi Micro Hei"; */
  color: rgb(34,34,34);
  background: #fff;
}
.user{
  width: 100%;
  height: 70px;
  display: flex;
  position: absolute;
  /* background-color:#B3212D; */
}
.back_icon{
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
}
.news{
  width: 100%;
  height: 70px;
  position: relative;
  /* margin-top: 56px; */
}
.user_right{
  margin-left: 12px;
  justify-content: center;
  display: flex;
  flex-direction: column;
}
.user_icon{
  width: 53px;
  height: 53px;
  margin-left: 15px;
  margin-top: 11px;
  border-radius: 50%;
}
.font{
  font-size: 14px;
  color:rgb(34,34,34);
  margin-bottom: 5px;
  letter-spacing: 1px;
  font-weight: bold;
}
.font1{
  font-size: 13px;
  color:#fff;
  margin-bottom: 2px;
  font-weight: bold;
}
.learn{
  width: calc(100% - 30px);
  margin-left: 15px;
  margin-top: 15px;
  /* border-radius: 8px; */
  /* height:132px; */
  background-color: #ececec;
  padding: 15px;
  box-sizing: border-box;
  border-radius: 5px;
}
.content{
  width: calc(100% - 30px);
  margin-left: 15px;
  margin-top: 15px;
  background-color: #fff;
  box-sizing: border-box;
}
.item{
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 40px;
  background-color: #ececec;
  margin-bottom: 10px;
  border-radius: 5px;
  /* border-bottom: 1px solid #e7e7e7; */
    padding-left: 15px;
  padding-right: 15px;
  justify-content: space-between;
}
.item1{
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 40px;
  justify-content: space-between;
  background-color: #ececec;
  margin-bottom: 10px;
  border-radius: 5px;
    padding-left: 15px;
  padding-right: 15px;
}
.item_left{
  display: flex;
  flex-direction: row;
  align-items: center;
}
.learn_title{
  font-size: 16px;
  color: rgb(34,34,34);
  line-height: 36px;
  font-weight: 600;
}
.learn_process{
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 40px;
}
.learn_icon{
  width: 26px;
  height: 26px;
  margin-right: 5px;
}
.learn_font{
  font-size: 12px;
  color: rgb(34,34,34);
  margin-right: 12px;
  font-weight: bold;
}
.item_icon{
  width: 18px;
  height:18px;
  margin-right: 6px;
}
.item_icon1{
  width: 20px;
  height:20px;
  margin-right: 4px;
}
.right_icon{
  width: 8px;
  height: auto;
}
.item_font{
  font-size: 12px;
  color: rgb(34,34,34);
}
.bottom{
  width: 100%;
  height: 50px;
  background-color: #fff;
  display: flex;
  flex-direction: row;
  position: fixed;
  bottom: 0;
  left: 0;
}
.bottom_item{
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.bottom_icon{
  width: 18px;
  height: 18px;
  margin-bottom: 5px;
}
.bottom_text{
  font-size: 14px;
  color: rgb(34,34,34);
}
.bottom_text_chose{
  font-size: 14px;
  color:#B3212D;
}
</style>

<script>
import { getmy } from '../apollo/apollo'
import { MessageBox } from 'mint-ui';

export default {
   components: {
    
  },
  data() {
    return {
      userImg:'./static/imgs/user.jpg',
      backImg:'./static/imgs/mybanner.png',
      ghImg:'./static/imgs/gh.png',
      kcImg:'./static/imgs/kc.png',
      mineImg:'./static/imgs/minechose.png',
      ganhuoImg:'./static/imgs/ganhuo.png',
      kechengImg:'./static/imgs/kecheng.png',
      youhuiImg:'./static/imgs/youhui.png',
      rightImg:'./static/imgs/right.png',
      bianqianImg:'./static/imgs/bianqian.png',
      weixinImg:'./static/imgs/weixin.png',
      clearImg:'./static/imgs/clear.png',
      getmy:getmy,
      getStudyDetails:{},
    }
  },
  computed:{
    
  },
  created() {
    this.getinit()
  },
  mounted(){
 
  },
  methods: {
    //清缓存
    clear(){
       MessageBox.confirm('请确认是否清楚缓存','提示').then(action => {
          sessionStorage.clear()
          window.location.href="https://screen.xiaoyima.work/index.html"
       }).catch(()=>{   

        });
    },
    toindex(){
      this.jump('./index')
    },
    toKc(){
      this.jump('./course')
    },
    mylabel(){
      this.$store.state.news={}
      this.$store.state.schoolFlag=0
      this.jump('./mylabel')
    },
    mycoupons(){
      this.jump('./mycoupons')
    },
    onCopy(){
      this.showOneBtnAlert('已成功复制小姨妈微信')
    },
    getinit(){
      this.$store.state.Authorization=sessionStorage.getItem('Authorization')
      this.$store.state.headimgurl=sessionStorage.getItem('headimgurl')
      this.$store.state.nickname=sessionStorage.getItem('nickname')
      document.title=this.$store.state.title;
      getmy().then(res=>{
        this.getStudyDetails=res.data.getStudyDetails;
        })
        .catch(err=>{
          this.msgManage(err)
        })
    },
    toGh(){
      this.jump('./ghList')
    },
    toRecord(){
      this.jump('./recordList')
    }


  }, 
  destroyed () {  
      
    
  },
  watch:{
    
  }
};
</script>


// WEBPACK FOOTER //
// src/views/my.vue